import { Children, cloneElement } from 'react';

export default function StudyExpectationsAllDocuments(props) {

    const {
        allExpectedStudyDocuments,
        allExpectedStaffDocuments,
        allowedMimeTypes,
        binderId,
        studyStage,
        studyTeam,
        onError,
        onFile,
        openFilePicker,
        setUploadedFileToExpectation,
        setTeamMemberIdUpload,
    } = props;

    return cloneElement(Children.only(props.children),
        {
            expectedStudyDocuments: allExpectedStudyDocuments,
            expectedStaffDocuments: allExpectedStaffDocuments,
            allowedMimeTypes,
            binderId,
            studyStage,
            studyTeam,
            onError,
            onFile,
            openFilePicker,
            setUploadedFileToExpectation,
            setTeamMemberIdUpload,
        });
}
